export const REFRESH_INTERVAL_MS = 30000;

export const freshenCacheBuster = (listUrl, now = Date.now()) =>
  String(listUrl).replace(/([?&]cache_remove=)\d+/, `$1${now}`);
